import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=94a1050e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94a1050e')) {
      api.createRecord('94a1050e', component.options)
    } else {
      api.reload('94a1050e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=94a1050e&", function () {
      api.rerender('94a1050e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2A7KW0VmcxbPA/JS/comp/ErrorMessage.vue"
export default component.exports